import {action, makeObservable, observable} from "mobx";

export class SnapshotStore {

    @observable extensionPresent = false;
    @observable snapshotUrl: undefined | string;
    @observable snapshotBlob: undefined | Blob;
    @observable triggerSnapshot: () => void;
    @observable isDashboardLoading = false;

    constructor() {
        makeObservable(this);
    }

    @action
    updateExtensionPresent = (next: boolean) => {
        this.extensionPresent = next;
    }

    @action
    updateSnapshotUrl = (url: string) => {
        this.snapshotUrl = url;
    }

    @action
    updateSnapshotBlob = (blob: Blob) => {
        this.snapshotBlob = blob;
    }

    @action resetSnapshot = () => {
        this.snapshotUrl = undefined;
        this.snapshotBlob = undefined;
    }

    @action
    updateSnapshotTrigger = (fn: () => void) => {
        this.triggerSnapshot = fn;
    }

    @action
    setDashboardLoading = (loading: boolean) => {
        this.isDashboardLoading = loading;
    };
}
